webpackJsonp([36,21],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormError_vue__ = __webpack_require__(189);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc19256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormError_vue__ = __webpack_require__(195);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc19256_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormError',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(194);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("75a52f96", content, true, {});

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".form-error{background-color:#fae0e5;border:1px solid #ed3a4f;border-radius:4px;text-align:center;padding:8px}.form-error .error-ico{float:left;width:22px}.form-error .error-msg{font-family:ProximanovaRegular;font-size:14px}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Templates/FormError.vue"],"names":[],"mappings":"AACA,YAAY,yBAAyB,yBAAyB,kBAAkB,kBAAkB,WAAW,CAC5G,AACD,uBAAuB,WAAW,UAAU,CAC3C,AACD,uBAAuB,+BAAiC,cAAc,CACrE","file":"FormError.vue","sourcesContent":["\n.form-error{background-color:#fae0e5;border:1px solid #ed3a4f;border-radius:4px;text-align:center;padding:8px\n}\n.form-error .error-ico{float:left;width:22px\n}\n.form-error .error-msg{font-family:\"ProximanovaRegular\";font-size:14px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-error"},[_c('p',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Slots_Popup_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Templates_FormError_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Templates_Loading_vue__ = __webpack_require__(170);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PopupContactSupport',
  props: ['closePopup'],
  data: function data() {
    return {
      formError: '',
      title: '',
      message: '',
      width: '30%',
      maxLength: 256,
      showLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['AppUser'])),
  components: {
    Popup: __WEBPACK_IMPORTED_MODULE_1__components_Slots_Popup_vue__["default"],
    FormError: __WEBPACK_IMPORTED_MODULE_2__components_Templates_FormError_vue__["default"],
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_Templates_Loading_vue__["default"]
  },
  created: function created() {
    this.CommitConfigStore();
  },
  mounted: function mounted() {
    $('textarea').keyup(function () {
      var length = $(this).val().length;
      var length = this.maxLength - length;
      $('#chars').text(length);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])(['CommitConfigStore']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actNotifyVendor']), {
    contactSupportCB: function contactSupportCB() {
      var _this = this;

      if (!this.isFormValid()) return;
      this.showLoading = true;

      var data = {
        email: this.AppUser.email,
        title: 'Dear Support Team',
        subject: this.title,
        message: this.message
      };

      this.actNotifyVendor(data).then(function (response) {

        _this.showLoading = false;

        if (response.error) {
          _this.formError = response.reason;
        } else {
          _this.closePopup();
        }
      }).catch(function (error) {
        // console.log('[Subscribe updatePasswordCB error]', error);
      });
    },
    isFormValid: function isFormValid() {
      return this.isTitleValid() && this.isMessageValid();
    },
    isTitleValid: function isTitleValid() {
      if (!this.title) {
        this.formError = 'Title is required';
        return false;
      } else if (this.title.startsWith(" ")) {
        this.formError = 'Remove Space At Beginning';
        return false;
      }

      this.formError = '';
      return true;
    },
    isMessageValid: function isMessageValid() {
      if (!this.message) {
        this.formError = 'Message is required';
        return false;
      } else if (this.message.startsWith(" ")) {
        this.formError = 'Remove Space At Beginning';
        return false;
      }

      this.formError = '';
      return true;
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactSupport_vue__ = __webpack_require__(334);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098764d3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactSupport_vue__ = __webpack_require__(436);
function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactSupport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098764d3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactSupport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("1135b97f", content, true, {});

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".cnt-support-form{margin:7% 10%}.cnt-support-form .vlt-input-group{margin-bottom:15px}.cnt-support-form .form-textarea-inp{height:100px;resize:none}.cnt-supp-form-error{margin-bottom:10px}.remaining{text-align:end;margin-bottom:25px;color:#000;font-family:ProximanovaRegular;font-size:14px;font-style:normal}.report-label{font-family:ProximanovaBold}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Popups/ContactSupport.vue"],"names":[],"mappings":"AACA,kBAAkB,aAAa,CAC9B,AACD,mCAAmC,kBAAkB,CACpD,AACD,qCAAqC,aAAa,WAAW,CAC5D,AACD,qBAAqB,kBAAkB,CACtC,AACD,WAAW,eAAe,mBAAmB,WAAW,+BAAiC,eAAe,iBAAiB,CACxH,AACD,cAAc,2BAA6B,CAC1C","file":"ContactSupport.vue","sourcesContent":["\n.cnt-support-form{margin:7% 10%\n}\n.cnt-support-form .vlt-input-group{margin-bottom:15px\n}\n.cnt-support-form .form-textarea-inp{height:100px;resize:none\n}\n.cnt-supp-form-error{margin-bottom:10px\n}\n.remaining{text-align:end;margin-bottom:25px;color:#000;font-family:\"ProximanovaRegular\";font-size:14px;font-style:normal\n}\n.report-label{font-family:\"ProximanovaBold\"\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',{attrs:{"closePopupEvent":_vm.closePopup,"width":_vm.width}},[_c('h6',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Report An Issue")]),_vm._v(" "),_c('div',{staticClass:"cnt-support-form"},[_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.contactSupportCB($event)}}},[_c('FormError',{directives:[{name:"show",rawName:"v-show",value:(_vm.formError),expression:"formError"}],staticClass:"cnt-supp-form-error",attrs:{"message":_vm.formError}}),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"autocomplete":"false","name":"hidden","type":"text"}}),_vm._v(" "),_c('div',{staticClass:"vlt-input-group"},[_c('label',{staticClass:"report-label"},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],attrs:{"type":"text","maxlength":"50"},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"vlt-input-group"},[_c('label',{staticClass:"report-label",staticStyle:{"margin-bottom":"10px"}},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"form-textarea-inp",attrs:{"rows":"4","maxLength":_vm.maxLength},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"remaining"},[_c('span',{attrs:{"id":"chars"}},[_vm._v("256")]),_vm._v(" characters")]),_vm._v(" "),_c('button',{staticClass:"btn-lg-primary",attrs:{"type":"submit","aria-label":"Submit button"}},[_vm._v("\n        Submit\n      ")]),_vm._v(" "),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}]})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/36.01211087870f0ab9f936.js